<section class="share-device" *ngIf="!powerMaster">
  <div class="container-fluid">
    <h5 translate>Share Device / Group</h5>
    <p-blockUI *ngIf="!this.isMsp && shareDeviceFeature" [blocked]="shareDeviceFeature" [target]="pnl">
      <button type="button" pButton label="{{'Locked' | translate}}" class="p-button-rounded p-button-secondary" icon="fa fa-lock" (click)="alertShareDeviceDialog();"></button>
    </p-blockUI>

    <div class="deviceRow">
      <div class="row">
        <div class="col-md-6">
          <p-panel #pnl>
            <div class="share">
              <p-table class="recipientTable" [value]="(deviceList$ | async)" [rows]="10" [paginator]="(deviceList$ | async).length!== 0"
                       [scrollable]="true" (onPage)="onPageloading($event)"  [scrollable]="true" scrollHeight="360px" [rowsPerPageOptions]="[10,20]">
                <ng-template pTemplate="caption">
                  {{'To other users' | translate}}
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
                  <tr [pSelectableRow]="rowData" [class.disabled]="(!this.isMsp && !shareDeviceFeature && rowData.type === 'device' && (rowData.isExpired || (!rowData.isExpired && !rowData.planActivate && !rowData.mspPlanActivate))) ? true : null" [ngClass]="{'trial_block': (!shareDeviceFeature && rowData.type === 'device' && rowData.canTrial)}">
                    <td class="col-nowrap">
                      <div class="recipient" [ngClass]="{'loading': dataLoading}" *ngIf="dataLoading else deviceList">
                        <div class="icon">
                          <div class="img-size">
                            <p-skeleton appearance="line" width="40px" height="40px"></p-skeleton>
                          </div>
                        </div>
                        <div class="data">
                          <div  style="margin: 4px 0 6px 0;"><p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 16, 'background-color': '#e9eef0'}"></p-skeleton></div>
                          <div>
                            <p-skeleton appearance="line" [theme]="{ 'width': '80%','height.px': 12, 'background-color': '#e9eef0'}"></p-skeleton>
                          </div>
                        </div>
                      </div>
                      <ng-template #deviceList>
                        <div class="recipient" [ngClass]="{'loading': dataLoading}" *ngIf="rowData.type === 'device'">
                          <div class="icon">
                            <div class="img-size">
                              <img class="responsive-image" [defaultImage]="'/assets/images/default_device.png'" [lazyLoad]="rowData.image" (error)="errorHandler($event)">
                            </div>
                          </div>
                          <div class="data">
                            <h5 style="margin: 0;">{{rowData.ObjectName}}</h5>
                            <div class="share-list">
                              <span class="material-icons people_alt" pTooltip="{{'Device Share' | translate}}" tooltipPosition="bottom"
                                    tooltipStyleClass="tooltips_gary" *ngIf="rowData.ObjectShareList && rowData.ObjectShareList.length !== 0">
                                people_alt
                              </span>
                              <div class="content-share">
                                <div class="people" *ngFor="let item of rowData.ObjectShareList;">
                                  <div class="badge {{item.statusType}} hidden-sm">
                                    <span *ngIf="selectedLang !== 'en' else defaultDeviceStatusType">{{item.statusType | translate}}</span>
                                    <ng-template #defaultDeviceStatusType><span>{{item.statusType}}</span></ng-template>
                                  </div>
                                  <span>{{item.SharedFirstName}} {{item.SharedLastName}}</span>
                                  <span class="dot">,</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="button">
                            <button type="button" pButton (click)="displayShareDeviceAlertDialog(rowData);" label="{{'Locked' | translate}}"
                                    class="p-button-rounded p-button-secondary" icon="fa fa-lock" *ngIf="!shareDeviceFeature && !powerMaster && (rowData.isExpired || (!rowData.isExpired && !rowData.planActivate && !rowData.mspPlanActivate)) && !this.isMsp"></button>
                            <!-- <button type="button" pButton (click)="displayisTrialDialog(rowData);" label="{{'Get Free Trial' | translate}}"
                              class="p-button-rounded" icon="fa fa-lock" *ngIf="rowData.isExpired && !powerMaster && rowData.type !== 'Group' && rowData.canTrial"></button> -->
                          </div>
                        </div>
                        <div class="recipient" [ngClass]="{'loading': dataLoading}" *ngIf="rowData.type === 'group'">
                          <div class="icon">
                            <div class="img-size group">
                              <div class="groupIcon">
                                <i class="fa fa-sitemap" aria-hidden="true"></i>
                              </div>
                            </div>
                          </div>
                          <div class="data">
                            <h5 style="margin: 0;">{{rowData.ObjectName}}</h5>
                            <div class="share-list">
                              <span class="material-icons people_alt" pTooltip="{{'Group Share' | translate}}" tooltipPosition="bottom"
                                    tooltipStyleClass="tooltips_gary" *ngIf="rowData.ObjectShareList && rowData.ObjectShareList.length !== 0">
                                people_alt
                              </span>
                              <div class="content-share">
                                <div class="people" *ngFor="let item of rowData.ObjectShareList;">
                                  <div class="badge {{item.statusType}} hidden-sm">
                                    <span *ngIf="selectedLang !== 'en' else defaultGroupStatusType">{{item.statusType | translate}}</span>
                                    <ng-template #defaultGroupStatusType><span>{{item.statusType}}</span></ng-template>
                                  </div>
                                  <span>{{item.SharedFirstName}} {{item.SharedLastName}}</span>
                                  <span class="dot">,</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </td>
                    <td class="col-btn" style="width:50px" *ngIf="!dataLoading">
                      <div *ngIf="rowData.type === 'device'">
                        <button pButton icon="fa fa-user-plus" (click)="addShareList(rowData);" *ngIf="!rowData.isExpired && (rowData.planActivate || rowData.mspPlanActivate)"></button>
                      </div>
                      <div *ngIf="rowData.type === 'group'">
                        <button pButton icon="fa fa-user-plus" (click)="addShareGroupList(rowData);"></button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr *ngFor="let item of dataLoadingView">
                    <td class="col-nowrap" *ngIf="dataLoading">
                      <div class="recipient" [ngClass]="{'loading': dataLoading}">
                        <div class="icon">
                          <div class="img-size">
                            <p-skeleton appearance="line" width="40px" height="40px"></p-skeleton>
                          </div>
                        </div>
                        <div class="data">
                          <div  style="margin: 4px 0 6px 0;"><p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 16, 'background-color': '#e9eef0'}"></p-skeleton></div>
                          <div>
                            <p-skeleton appearance="line" [theme]="{ 'width': '80%','height.px': 12, 'background-color': '#e9eef0'}"></p-skeleton>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="ui-emptymessage" *ngIf="!dataLoading" translate>No Data found</div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </p-panel>
        </div>
        <div class="col-md-6">
          <div class="share from">
            <p-table class="recipientTable" [value]="(deviceSharingList$ | async)" [rows]="10" [paginator]="(deviceSharingList$ | async).length!== 0"
            [scrollable]="true" (onPage)="onPageloading($event)"  [scrollable]="true" scrollHeight="360px" [rowsPerPageOptions]="[10,20]">
              <ng-template pTemplate="caption">
                {{'From other users' | translate}}
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
                <tr [pSelectableRow]="rowData">
                  <td class="col-nowrap">
                    <div class="recipient" [ngClass]="{'loading': dataLoading}" *ngIf="dataLoading else deviceSharingList">
                      <div class="icon">
                        <div class="img-size">
                          <p-skeleton appearance="line" width="40px" height="40px"></p-skeleton>
                        </div>
                      </div>
                      <div class="data">
                        <div  style="margin: 4px 0 6px 0;"><p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 16, 'background-color': '#e9eef0'}"></p-skeleton></div>
                        <div>
                          <p-skeleton appearance="line" [theme]="{ 'width': '80%','height.px': 12, 'background-color': '#e9eef0'}"></p-skeleton>
                        </div>
                      </div>
                    </div>
                    <ng-template #deviceSharingList>
                      <div class="recipient" [ngClass]="{'loading': dataLoading}" *ngIf="rowData.type === 'device'">
                        <div class="icon">
                          <div class="img-size">
                            <img class="responsive-image" [defaultImage]="'/assets/images/default_device.png'" [lazyLoad]="rowData.image" (error)="errorHandler($event)">
                            <!-- <img [hidden]="dataLoading" (load)="onLoad()" src="{{rowData.image}}" (error)="errorHandler($event)" class="responsive-image" style="width: 40px;">
                            <img *ngIf="dataLoading" src="/assets/images/default_device.png" alt="loading" class="responsive-image" style="width: 40px;"> -->
                          </div>
                        </div>
                        <div class="data">
                          <h5 style="margin: 0;">{{rowData.DeviceName}}</h5>
                          <div class="share-list">
                            <span class="material-icons people_alt" pTooltip="{{'Device Share' | translate}}" tooltipPosition="bottom"
                                  tooltipStyleClass="tooltips_gary">
                              people_alt
                            </span>
                            <div class="content-share">
                              <div class="people">
                                <span>{{rowData.FirstName}} {{rowData.LastName}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="recipient" [ngClass]="{'loading': dataLoading}" *ngIf="rowData.type === 'group'">
                        <div class="icon">
                          <div class="img-size group">
                            <div class="groupIcon">
                              <i class="fa fa-sitemap" aria-hidden="true"></i>
                            </div>
                          </div>
                        </div>
                        <div class="data">
                          <h5 style="margin: 0;">{{rowData.GroupName}}</h5>
                          <div class="share-list">
                            <span class="material-icons people_alt" pTooltip="{{'Group Share' | translate}}" tooltipPosition="bottom"
                                  tooltipStyleClass="tooltips_gary">
                              people_alt
                            </span>
                            <div class="content-share">
                              <div class="people">
                                <span>{{rowData.FirstName}} {{rowData.LastName}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </td>
                  <td class="col-btn" style="width:40px" *ngIf="!dataLoading">
                    <div *ngIf="rowData.type === 'device'">
                      <p-button icon="pi pi-times" class="ui-btn-outline" *ngIf="rowData.status === 0" (click)="rejectSharedDevice(rowData);"></p-button>
                    </div>
                    <div *ngIf="rowData.type === 'group'">
                      <p-button icon="pi pi-times" class="ui-btn-outline" *ngIf="rowData.status === 0" (click)="rejectSharedGroup(rowData);"></p-button>
                    </div>
                  </td>
                  <td class="col-btn" style="width:50px" *ngIf="!dataLoading">
                    <div *ngIf="rowData.type === 'device'">
                      <button pButton icon="fa fa-trash" *ngIf="(rowData.status !== 0) else Accepte" (click)="confirmDeleteSharedDevice(rowData)"></button>
                      <ng-template #Accepte>
                        <button pButton icon="pi pi-check" (click)="acceptSharedDvice(rowData);"></button>
                      </ng-template>
                    </div>
                    <div *ngIf="rowData.type === 'group'">
                      <button pButton icon="fa fa-trash" *ngIf="(rowData.status !== 0) else Accepte" (click)="confirmDeleteSharedGroup(rowData)"></button>
                      <ng-template #Accepte>
                        <button pButton icon="pi pi-check" (click)="acceptSharedGroup(rowData);"></button>
                      </ng-template>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr *ngFor="let item of dataLoadingView">
                  <td class="col-nowrap" *ngIf="dataLoading">
                    <div class="recipient" [ngClass]="{'loading': dataLoading}">
                      <div class="icon">
                        <div class="img-size">
                          <p-skeleton appearance="line" width="40px" height="40px"></p-skeleton>
                        </div>
                      </div>
                      <div class="data">
                        <div  style="margin: 4px 0 6px 0;"><p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 16, 'background-color': '#e9eef0'}"></p-skeleton></div>
                        <div>
                          <p-skeleton appearance="line" [theme]="{ 'width': '80%','height.px': 12, 'background-color': '#e9eef0'}"></p-skeleton>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="ui-emptymessage" *ngIf="!dataLoading" translate>No Data found</div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>

<!-- Share List -->
<p-dialog header="{{'Share List' | translate}}" [(visible)]="displayShareListDialog" [modal]="true" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}" [baseZIndex]="10000">
  <div class="dialog-content">
    <blockquote class="blockquote text-center">
      <h5 style="font-size: 1.25rem !important;">{{sharedDeviceName}}</h5>
      <p style="font-size: 15px !important;" translate>will be shared with</p>
    </blockquote>
    <div class="form-group">
      <label translate>User Name</label>
      <input type="text" size="30" class="form-control pInputText" placeholder="E-mail" pInputText [(ngModel)]="shareDeviceListInput" pattern="^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
             #emailshareDevice="ngModel">
      <p *ngIf="userNameFlag" style="font-size:3;color: red;" translate>You can't share with yourself.</p>
    </div>
    <div *ngIf="shareDeviceList.length !== 0">
      <div class="form-group" style="margin: 0 !important;">
        <label translate>Shared With</label>
      </div>
      <p-table class="recipientTable" [value]="shareDeviceList" [(selection)]="selectedNode" [paginator]="false" [rows]="10" [scrollable]="true">
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
          <tr [pSelectableRow]="rowData">
            <td class="col-nowrap">
              <div class="recipient" [ngClass]="{'loading': dataLoading}">
                <div class="icon">
                  <span class="fa-stack fa-lg">
                    <i class="fa fa-circle fa-stack-2x {{rowData.statusType}}"></i>
                    <i class="fa-stack-1x name">{{rowData.SharedFirstName.substr(0,1)}}</i>
                  </span>
                </div>
                <div class="data">
                  <h5 style="margin: 0;">{{rowData.SharedFirstName}} {{rowData.SharedLastName}}</h5>
                  <p>{{rowData.statusType | translate}}</p>
                </div>
              </div>
            </td>
            <td class="col-btn" style="width:50px">
              <button pButton icon="fa fa-trash" (click)="confirmRemoveShareList(rowData)"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Share Device' | translate}}" class="ui-button-danger" (click)="comfirmShareList()" [disabled]="emailshareDevice.invalid || shareDeviceListInput === ''"></button>
    <button type="button" pButton (click)="this.displayShareListDialog= false;" label="{{'Cancel' | translate}}"
            class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Share Group List -->
<p-dialog header="{{'Share group list' | translate}}" [(visible)]="displayShareGroupListDialog" [modal]="true" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}" [baseZIndex]="10000">
  <div class="dialog-content">
    <blockquote class="blockquote text-center">
      <h5 style="font-size: 1.25rem !important;">{{sharedGroupName}}</h5>
      <p style="font-size: 15px !important;" translate>will be shared with</p>
    </blockquote>
    <div class="form-group">
      <label translate>User Name</label>
      <input type="text" size="30" class="form-control pInputText" placeholder="E-mail" pInputText [(ngModel)]="shareGroupListInput" pattern="^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
             #emailshareGroup="ngModel">
      <p *ngIf="userNameFlag" style="font-size:3;color: red;" translate>You can't share with yourself.</p>
    </div>
    <div *ngIf="shareGroupList && shareGroupList.length !== 0">
      <div class="form-group" style="margin: 0 !important;">
        <label translate>Shared With</label>
      </div>
      <p-table class="recipientTable" [value]="shareGroupList" [(selection)]="selectedGroupNode" [paginator]="false" [rows]="10" [scrollable]="true">
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
          <tr [pSelectableRow]="rowData">
            <td class="col-nowrap">
              <div class="recipient" [ngClass]="{'loading': dataLoading}">
                <div class="icon">
                  <span class="fa-stack fa-lg">
                    <i class="fa fa-circle fa-stack-2x {{rowData.statusType}}"></i>
                    <i class="fa-stack-1x name">{{rowData.SharedFirstName.substr(0,1)}}</i>
                  </span>
                </div>
                <div class="data">
                  <h5 style="margin: 0;">{{rowData.SharedFirstName}} {{rowData.SharedLastName}}</h5>
                  <p>{{rowData.statusType | translate}}</p>
                </div>
              </div>
            </td>
            <td class="col-btn" style="width:50px">
              <button pButton icon="fa fa-trash" (click)="confirmRemoveShareGroupList(rowData)"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Share Group' | translate}}" class="ui-button-danger" (click)="comfirmShareGroupList()" [disabled]="emailshareGroup.invalid || shareGroupListInput === ''"></button>
    <button type="button" pButton (click)="this.displayShareGroupListDialog= false;" label="{{'Cancel' | translate}}"
            class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Confirm Share -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displayConfirmShareDialog" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog" [baseZIndex]="10000">
  <div class="page-content-body">
    <p style="padding-bottom: 10px;" translate>Are you sure you want to share this device?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn grid">
      <button type="button" pButton label="{{'Yes' | translate}}" class="ui-button-danger" (click)="saveShareList();"></button>
      <button type="button" pButton (click)="displayConfirmShareDialog=false; displayShareListDialog= true;" label="{{'No' | translate}}" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Confirm Share Group -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displayConfirmShareGroupDialog" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog" [baseZIndex]="10000">
  <div class="page-content-body">
    <p style="padding-bottom: 10px;" translate>Are you sure you want to share this group?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn grid">
      <button type="button" pButton label="{{'Yes' | translate}}" class="ui-button-danger" (click)="saveShareGroupList();"></button>
      <button type="button" pButton (click)="displayConfirmShareGroupDialog=false; displayShareGroupListDialog= true;" label="{{'No' | translate}}" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Confirm Remove Share-->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displayConfirmRemoveDialog" [modal]="true" [style]="{'width': '450px'}" [baseZIndex]="10000"
          class="ConfirmDialog">
  <div class="dialog-content">
    <blockquote class="blockquote text-left">
      <h5 style="font-size: 1.1rem !important;">{{'Remove' | translate}} {{sharedUserName}} ?</h5>
    </blockquote>
  </div>
  <div class="page-content-body">
    <!-- <p translate *ngIf="confirmShare">Do you really want to delete this record?</p> -->
    <p translate>Do you really want to stop sharing this device?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn grid">
      <button type="button" pButton label="{{'Remove' | translate}}" class="ui-button-danger" (click)="removeShareList()"></button>
      <button type="button" pButton (click)="displayConfirmRemoveDialog=false; this.displayShareListDialog= true;" label="{{'Cancel' | translate}}"
              class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Confirm Remove Share Group-->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displayConfirmRemoveGroupDialog" [modal]="true" [style]="{'width': '450px'}" [baseZIndex]="10000"
          class="ConfirmDialog">
  <div class="dialog-content">
    <blockquote class="blockquote text-left">
      <h5 style="font-size: 1.1rem !important;">{{'Remove' | translate}} {{sharedUserName}} ?</h5>
    </blockquote>
  </div>
  <div class="page-content-body">
    <p translate>Do you really want to stop sharing this group?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn grid">
      <button type="button" pButton label="{{'Remove' | translate}}" class="ui-button-danger" (click)="removeShareGroupList()"></button>
      <button type="button" pButton (click)="displayConfirmRemoveGroupDialog=false; this.displayShareGroupListDialog= true;" label="{{'Cancel' | translate}}"
              class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>


<!-- Confirm delete Shared-->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displayConfirmDeleteDialog" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog" [baseZIndex]="10000">
  <div class="page-content-body">
    <p style="padding-bottom: 10px;" translate>Are you sure you want to delete this shared device?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn grid">
      <button type="button" pButton label="{{'Yes' | translate}}" class="ui-button-danger" (click)="deleteSharedDevice();"></button>
      <button type="button" pButton (click)="displayConfirmDeleteDialog=false" label="{{'No' | translate}}" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Confirm delete Shared Group-->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displayConfirmDeleteGroupDialog" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog" [baseZIndex]="10000">
  <div class="page-content-body">
    <p style="padding-bottom: 10px;" translate>Are you sure you want to delete this shared group?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="{{'Yes' | translate}}" class="ui-button-danger" (click)="deleteSharedGroup();"></button>
      <button type="button" pButton (click)="displayConfirmDeleteGroupDialog=false" label="{{'No' | translate}}" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>


<app-dialog></app-dialog>
